<template>
    <el-dialog title="分配专家" :visible.sync="isShowDialog" width="774px" @open="handleOpen">
        <div class="divZJ" :style="{height: scrollerHeight}">
            <el-form :model="form" label-width="160px">
                 <el-form-item label="是否需要添加组长">
                    <el-radio-group v-model="form.needLeader" @change="handleChangeNeed">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="form.needLeader === 1" label="添加专家组长" prop="expert_leader_ids">
                    <el-select
                            v-model="form.expert_leader_ids"
                            multiple
                            style="width: 100%"
                            placeholder="请选择"
                            filterable>
                        <el-option
                            v-for="item in zjlist"
                            :key="item.id"
                            :label="item.name"
                            :disabled="form.expert_ids.includes(item.id)"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="添加专家" prop="expert_ids">
                    <el-select
                            v-model="form.expert_ids"
                            multiple
                            style="width: 100%"
                            placeholder="请选择"
                            filterable>
                        <el-option
                            v-for="item in zjlist"
                            :key="item.id"
                            :label="item.name"
                            :disabled="form.expert_leader_ids.includes(item.id)"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button @click="isShowDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitZJ">确 定</el-button>
                </span>
    </el-dialog>
</template>

<script>
import {
    getExpert,
    setExpert
} from "../../utils/api.js";

export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        model: {
			type: Object,
			default: () => ({})
		},
		reAssign: { // 赋初始值
			type: Boolean,
			default: false
		}
    },
    data() {
        return {
            isShowDialog: false,
            form: this.genDefaultForm(),
            zjlist: [],
            zjlistMap: {},
            activeIds: [],
        }
    },
    watch: {
        show(val) {
            this.isShowDialog = val
        },
        isShowDialog(val) {
            this.$emit('update:show', val)
        }
    },
    computed: {
        scrollerHeight: function() {
            return (window.innerHeight - 350) + 'px'; //自定义高度需求
        }
    },
    methods: {
        genDefaultForm() {
            return {
                needLeader: 0,
                expert_ids: [],
                expert_leader_ids: []
            }
        },
        submitZJ() {
            const { form } = this
            setExpert(this.model.id, {
                is_reset: this.reAssign ? 1 : undefined,
                expert_ids: form.expert_ids,
                expert_leader_ids: form.expert_leader_ids
            }).then(res => {
                this.$message.success(`分配专家成功`)
                this.$emit('success')
            }).catch((err) => {
                this.$message.error(err);
            })
        },
        handleChangeNeed() {
            this.form.expert_leader_ids = []
        },
        handleOpen() {
            this.form = this.genDefaultForm()
            if (this.reAssign) {
                const model = this.model
                this.form.needLeader =
                    model.expert_leader_ids && model.expert_leader_ids.length > 0 ? 1 : 0
                this.form.expert_leader_ids = model.expert_leader_ids || []
                this.form.expert_ids = model.expert_ids || []
            }
        }
    },
    mounted() {
        getExpert().then(res => {
            this.zjlist = res || [];
            this.zjlistMap = this.zjlist.reduce((res, item) => {
                res[item.id] = item
                return res
            }, {})
        })
    }
}
</script>

<style lang="less" scoped>
.radio01 {
    background:#F5F6F7;
    margin-bottom:15px;
    border: none !important;
    width:100px;
    margin-left: 10px;
    margin-right: 10px;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
}
.group-wrapper {
    display: flex;
    padding: 10px;
}
.group-box {
    flex: 1;
    width: 571px;
    margin-left: 10px;
    min-height: 36px;
    padding: 10px;
    border: 1px solid #EBEEF5;
}
</style>